module.exports = __webpack_public_path__ + "c16b3cd56719e2cfc1c937836442581f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-23.png
// module id = 2669
// module chunks = 0